import styled from "styled-components";

import { TableCell } from "components/ui/table-final-saviour/Table/TableCell";
import { TableHeaderCell } from "components/ui/table-final-saviour/Table/TableHeaderCell";
import { Column, Row, TableCellBaseProps } from "components/ui/table-final-saviour/Table/table.types";

const FlexContainer = styled.div`
    display: flex;
    justify-content: center;
`;

const ChipsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    row-gap: 0.25rem;
    column-gap: 0.5rem;
    justify-content: center;
`;

type Options<T extends Row> = {
    title?: string;
    width?: number;
    getChips: (props: TableCellBaseProps<T>) => React.ReactNode;
};

export const createChipsColumn = <T extends Row>(options: Options<T>): Column<T> => {
    const { getChips } = options;

    return {
        _type: "chips",
        components: {
            TableHeaderCell: (props) => (
                <TableHeaderCell {...props} width={options.width} align={"center"}>
                    {options.title}
                </TableHeaderCell>
            ),
            TableCell: (props) => {
                return (
                    <TableCell {...props} width={options.width}>
                        <FlexContainer>
                            <ChipsContainer>{getChips(props)}</ChipsContainer>
                        </FlexContainer>
                    </TableCell>
                );
            },
        },
    };
};
